export const HeaderLocalRemoteVersion = {
  'mfe-header': { environment: 'local' as const },
};

export const HeaderTestRemoteVersion = {
  'mfe-header': { version: '2.*', environment: 'test' as const },
};
